import { Http } from '@angular/http';
import { Device, DeviceV2 } from '../models/device.model';
/**
 * @license
 * Copyright (c) Absa Group Limited, All Rights Reserved.
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class MfaDeviceService {
  private baseUrlFGW = '/api/Devices';
  private baseUrlDevicesV2 = '/api/devicesv2';
  private baseUrlOnlineMfa = '/api/onlinemfa';

  private headers() {
    return new HttpHeaders({
      Authorization: `Bearer ${sessionStorage.getItem('authorizationData')}`,
    });
  }

  constructor(protected httpClient: HttpClient, protected http: Http) {}

  public getMfaDeviceNotActive(): Observable<any> {
    return this.httpClient.get(`${this.baseUrlFGW}/notActive`, { headers: this.headers() });
  }

  public getMfaDevice(): Observable<any> {
    return this.httpClient.get(`${this.baseUrlFGW}`, { headers: this.headers() });
  }

  public getUniqueCode(deviceName: string): Observable<any> {
    return this.httpClient.post(`${this.baseUrlFGW}/provisional-encrypted-secret-activation`, { deviceName }, { headers: this.headers() });
  }

  public getQRCode(deviceName: string): Observable<any> {
    return this.httpClient.post(`${this.baseUrlFGW}/provisional-activation/json`, { deviceName }, { headers: this.headers() });
  }

  public postDeactivateDevice(token: string): Observable<any> {
    return this.httpClient.post(`${this.baseUrlFGW}/deactivate`, { token }, { headers: this.headers() });
  }

  public putEditDevice(device: Device, deviceAlias: string): Observable<any> {
    return this.httpClient.put(`${this.baseUrlFGW}/${device.id}`, { deviceAlias }, { headers: this.headers() });
  }

  public getMfaDeviceV2(): Observable<any> {
    return this.httpClient.get(`${this.baseUrlDevicesV2}`, { headers: this.headers() });
  }

  public postEnableMfaWithCode(deviceId: string, totp: string): Observable<any> {
    return this.httpClient.post(
      `${this.baseUrlOnlineMfa}/enable`,
      {
        id: deviceId,
        totp: totp,
      },
      { headers: this.headers() }
    );
  }

  public postDisableMfaWithCode(deviceId: string, totp: string): Observable<any> {
    return this.httpClient.post(
      `${this.baseUrlOnlineMfa}/disable`,
      {
        id: deviceId,
        totp: totp,
      },
      { headers: this.headers() }
    );
  }

  public postDeactivateMfaForDeviceV2(deviceId: string, token: string): Observable<any> {
    return this.httpClient.post(
      `${this.baseUrlOnlineMfa}/deactivate`,
      {
        id: deviceId,
        token: token,
      },
      { headers: this.headers() }
    );
  }

  public postProvisionalActivationQrCode(deviceId: string): Observable<any> {
    return this.httpClient.post(
      `${this.baseUrlOnlineMfa}/provisional-activation/json`,
      {
        id: deviceId,
      },
      { headers: this.headers() }
    );
  }

  public postProvisionalActivationShortCode(deviceId: string): Observable<any> {
    return this.httpClient.post(
      `${this.baseUrlOnlineMfa}/provisional-activation/short-code`,
      {
        id: deviceId,
      },
      { headers: this.headers() }
    );
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/manage-mfa-device/services/mfa-device.service.ts